import Box from "@mui/material/Box"
import { ReactNode, useRef } from "react"
import { useScrollOverflow } from "../../hooks/useScrollOverflow"
import { ScrollableContainer } from "../../style/styles"
import EdgeFade from "./EdgeFade"

interface Props {
    children: ReactNode
    id?: string
    className?: string
}

/**
 * A scrollable panel whose top / bottom edge fades into the background while there is more
 * content past it — as in On Air's live grid. The panel's scrollbar can be overlaid and
 * hidden, and two panels stacked in a split would otherwise look cut off; the fade says
 * "there is more" and keeps the panel below visually apart. It stops short of the scrollbar.
 */
const FadingScrollContainer = ({ children, id, className }: Props) => {
    const scrollRef = useRef<HTMLDivElement>(null)
    const overflow = useScrollOverflow(scrollRef)

    const fade = (edge: "top" | "bottom") =>
        overflow[edge] && <EdgeFade edge={edge} inset={{ right: overflow.scrollbarWidth }} />

    return (
        <Box position="relative" width="100%" height="100%" minHeight={0}>
            <ScrollableContainer ref={scrollRef} id={id} className={className}>
                {children}
            </ScrollableContainer>
            {fade("top")}
            {fade("bottom")}
        </Box>
    )
}

export default FadingScrollContainer
